export default __webpack_public_path__ + "static/media/seiz.8dd0c90e.jpg";